import { Steven } from 'helpers/steven';
import initLegacyTracker from 'javascripts/services/legacy_tracker';

Steven.start();
initLegacyTracker();
